import { isSameDay } from "./is-same-day.mjs";
export function isToday(date, timeZone) {
  return isSameDay(date, new Date(), timeZone);
}